export const imgRoute = (state = '/img/') => state;
